import React, { lazy } from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
import { ArtifactCard } from '../shared/ArtifactCard';
import { motion } from 'framer-motion';
const PRODUCTOS_BG = 'https://cdn.shopify.com/s/files/1/0661/3847/2542/files/mm8DHXzU7JhvCgYay4N1kmyc5Q2WN4pg9GNtp0heMg7BSrM3QpCC0xGOYBCXzy5-GOp2Z8fowqxSWnS4ldgA120xXC67zpfx2qL_wjuAepxGwDo6ErItRpus49bMEA7U.jpg?v=1778629864';
const GOLD = '#C9A84C';
const GOLD_LIGHT = '#E8D48B';
const SigilShadow = ({
  color
}: {
  color: string;
}) => <svg width="44" height="44" viewBox="0 0 44 44" fill="none" data-id="element-111">
    <circle cx="22" cy="22" r="20" stroke={color} strokeWidth="0.8" opacity="0.6" data-id="element-112" />
    <path d="M22 6 L30 22 L22 38 L14 22 Z" stroke={color} strokeWidth="1" fill={color} fillOpacity="0.15" data-id="element-113" />
    <circle cx="22" cy="22" r="4" fill={color} data-id="element-114" />
  </svg>;
const SigilCompat = ({
  color
}: {
  color: string;
}) => <svg width="44" height="44" viewBox="0 0 44 44" fill="none" data-id="element-115">
    <circle cx="14" cy="22" r="10" stroke={color} strokeWidth="0.8" opacity="0.7" data-id="element-116" />
    <circle cx="30" cy="22" r="10" stroke={color} strokeWidth="0.8" opacity="0.7" data-id="element-117" />
    <circle cx="22" cy="22" r="2.5" fill={color} data-id="element-118" />
  </svg>;
const SigilRitual = ({
  color
}: {
  color: string;
}) => <svg width="44" height="44" viewBox="0 0 44 44" fill="none" data-id="element-119">
    <circle cx="22" cy="22" r="20" stroke={color} strokeWidth="0.8" opacity="0.6" data-id="element-120" />
    <circle cx="22" cy="22" r="10" fill={color} fillOpacity="0.15" data-id="element-121" />
    <path d="M14 22 A8 8 0 0 1 30 22" stroke={color} strokeWidth="1.2" fill="none" data-id="element-122" />
    <circle cx="14" cy="22" r="1.5" fill={color} data-id="element-123" />
    <circle cx="30" cy="22" r="1.5" fill={color} data-id="element-124" />
  </svg>;
const SigilCamara = ({
  color
}: {
  color: string;
}) => <svg width="44" height="44" viewBox="0 0 44 44" fill="none" data-id="element-125">
    <circle cx="22" cy="22" r="20" stroke={color} strokeWidth="0.8" opacity="0.6" data-id="element-126" />
    {[0, 72, 144, 216, 288].map(a => <line key={a} x1="22" y1="22" x2="22" y2="6" stroke={color} strokeWidth="0.7" opacity="0.7" transform={`rotate(${a} 22 22)`} data-id="element-127" />)}
    <circle cx="22" cy="22" r="3" fill={color} data-id="element-128" />
  </svg>;
const SigilBundle = ({
  color
}: {
  color: string;
}) => <svg width="52" height="52" viewBox="0 0 52 52" fill="none" data-id="element-129">
    <circle cx="26" cy="26" r="24" stroke={color} strokeWidth="0.8" opacity="0.5" data-id="element-130" />
    <circle cx="26" cy="26" r="18" stroke={color} strokeWidth="0.6" strokeDasharray="2 2" opacity="0.6" data-id="element-131" />
    {[0, 60, 120, 180, 240, 300].map(a => <circle key={a} cx="26" cy="6" r="2" fill={color} transform={`rotate(${a} 26 26)`} data-id="element-132" />)}
    <path d="M26 14 L34 26 L26 38 L18 26 Z" stroke={color} strokeWidth="1" fill={color} fillOpacity="0.2" data-id="element-133" />
    <circle cx="26" cy="26" r="3.5" fill={color} data-id="element-134" />
  </svg>;
export function Productos() {
  const addOns = [{
    id: 'sombrio',
    title: 'Archivo Sombrío',
    description: 'Patrones ocultos, heridas simbólicas y reacciones internas que tu signo suele esconder.',
    microcopy: 'Archivo reservado actualmente dentro del universo expandido.',
    price: '$9',
    sigil: <SigilShadow color={GOLD} data-id="element-135" />
  }, {
    id: 'compatibilidad',
    title: 'Códice de Compatibilidad',
    description: 'Cómo se relaciona tu arquetipo con otras energías: atracción, tensión, choque y magnetismo.',
    microcopy: 'Próximamente disponible para conexiones avanzadas entre entidades.',
    price: '$10',
    sigil: <SigilCompat color={GOLD} data-id="element-136" />
  }, {
    id: 'ritual',
    title: 'Ritual del Eclipse',
    description: 'Un ritual simbólico de conexión con la energía de tu signo para integrar su fuerza de forma consciente.',
    microcopy: 'Experiencia ritual actualmente en preparación.',
    price: '$8',
    sigil: <SigilRitual color={GOLD} data-id="element-137" />
  }, {
    id: 'camara',
    title: 'Cámara Astral',
    description: 'Experiencia sonora y visual complementaria para sumergirte en la atmósfera de tu reino.',
    microcopy: 'Experiencia inmersiva en desarrollo dentro del reino.',
    price: '$12',
    sigil: <SigilCamara color={GOLD} data-id="element-138" />
  }];
  return <section className="relative py-20 px-6 overflow-hidden" data-id="element-139">
      {/* Background image */}
      <div className="absolute inset-0 z-0" data-id="element-140">
        <img src={PRODUCTOS_BG} alt="" aria-hidden="true" className="w-full h-full object-cover" loading="lazy" data-id="element-141" />
        <div className="absolute inset-0 bg-cosmic-black/85" data-id="element-142" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, #050508 0%, rgba(5,5,8,0.5) 50%, #050508 100%)'
      }} data-id="element-143" />
      </div>

      <div className="relative z-10 container mx-auto max-w-6xl" data-id="element-144">
        <AnimatedSection data-id="element-145">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-white mb-4" data-id="element-146">
            Desbloquea Tu Reino
          </h2>
          <p className="text-gold-light/80 text-center mb-12 italic" data-id="element-147">
            Comienza tu travesía
          </p>
        </AnimatedSection>

        {/* Core Product */}
        <AnimatedSection delay={0.15} data-id="element-148">
          <div className="mb-24 max-w-2xl mx-auto" data-id="element-149">
            <motion.div className="relative border-2 border-gold-primary rounded-xl p-8 md:p-10 text-center overflow-hidden" style={{
            background: 'linear-gradient(145deg, rgba(10,10,18,0.95) 0%, rgba(201,168,76,0.10) 100%)',
            boxShadow: '0 0 50px rgba(201,168,76,0.35)'
          }} data-id="element-150">
              <motion.div className="absolute inset-0 rounded-xl pointer-events-none" animate={{
              boxShadow: ['inset 0 0 30px rgba(201,168,76,0.15)', 'inset 0 0 60px rgba(201,168,76,0.30)', 'inset 0 0 30px rgba(201,168,76,0.15)']
            }} transition={{
              duration: 4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-151" />
              <div className="relative" data-id="element-152">
                <p className="text-xs tracking-[0.3em] uppercase mb-3 font-serif text-gold-primary" data-id="element-153">
                  Acceso Disponible
                </p>
                <h3 className="text-2xl md:text-3xl font-serif font-bold text-gold-light mb-4" data-id="element-154">
                  Núcleo del Arquetipo
                </h3>
                <p className="text-gray-300 mb-6 max-w-md mx-auto" data-id="element-155">
                  La experiencia fundamental de tu arquetipo. La primera puerta
                  hacia tu reino.
                </p>
                <p className="text-5xl font-bold text-gold-primary mb-8 font-serif" data-id="element-156">
                  $9.99
                </p>
                <p className="text-sm text-gold-light/70 italic" data-id="element-157">
                  Selecciona tu signo arriba para acceder a tu reino.
                </p>
              </div>
            </motion.div>
          </div>
        </AnimatedSection>

        {/* Sealed Archives */}
        <AnimatedSection delay={0.3} data-id="element-158">
          <div className="text-center mb-12" data-id="element-159">
            <motion.div className="inline-flex items-center gap-3 mb-6" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} data-id="element-160">
              <div className="h-px w-12 bg-gradient-to-r from-transparent to-gold-primary" data-id="element-161" />
              <span className="text-[11px] tracking-[0.4em] uppercase font-serif text-gold-light" data-id="element-162">
                Universo Expandido
              </span>
              <div className="h-px w-12 bg-gradient-to-r from-gold-primary to-transparent" data-id="element-163" />
            </motion.div>

            <h3 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-164">
              Archivos Adicionales
            </h3>

            <p className="max-w-2xl mx-auto text-base md:text-lg font-serif italic leading-relaxed" style={{
            color: 'rgba(232,212,139,0.88)',
            textShadow: '0 0 20px rgba(201,168,76,0.35)'
          }} data-id="element-165">
              El Reino continúa expandiéndose.
              <br data-id="element-166" />
              Nuevos archivos, rituales y experiencias serán desbloqueados
              dentro del universo LOS 12.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-167">
            {addOns.map((addOn, index) => <motion.div key={addOn.id} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1 + index * 0.12,
            duration: 0.7
          }} data-id="element-168">
                <ArtifactCard title={addOn.title} description={addOn.description} microcopy={addOn.microcopy} price={addOn.price} signColor={GOLD} sigil={addOn.sigil} data-id="element-169" />
              </motion.div>)}
          </div>
        </AnimatedSection>

        {/* Sealed Bundle */}
        <AnimatedSection delay={0.5} data-id="element-170">
          <div className="max-w-3xl mx-auto" data-id="element-171">
            <ArtifactCard title="Acceso Completo al Reino" description="Expansión completa del reino: todos los archivos, rituales y experiencias unificadas en una sola travesía." microcopy="Expansión completa del reino próximamente disponible." price="$34.99" signColor={GOLD_LIGHT} isBundle sigil={<SigilBundle color={GOLD_LIGHT} data-id="element-173" />} data-id="element-172" />
          </div>
        </AnimatedSection>
      </div>
    </section>;
}